import React from 'react';

import * as styles from './ControlsLayout.css';

export const ControlsLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children} </div>;
};
